import Api from "../../axios";

export default async function apiLeaveApprovalList() {
  return await Api.get(`/leave_approval_list`);
}
